import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'antd';
import { txt } from 'libs/i18n';
import { isStartPlan, isOtherEditionPlanActive, getActiveSubscriptionByPlanKey, isBeeyPlan, isEnterprisePlan, } from 'api/model/subscription-plan';
const PurchaseButton = ({ plan, editionSubscriptions, quantity, onCreateOrder, onCreatePortalSession, }) => {
    const isEnterprise = isEnterprisePlan(plan.key);
    const isBeeyStart = isStartPlan(plan.key, plan.isRecurring);
    const isBeey = isBeeyPlan(plan.key);
    const activeSubscription = getActiveSubscriptionByPlanKey(editionSubscriptions, plan.key);
    const isCurrentActive = activeSubscription !== undefined && activeSubscription.isActive
        && activeSubscription.cancelAtDate === null;
    const isEditionCanceling = editionSubscriptions.find((sub) => sub.isActive
        && sub.cancelAtDate !== null) !== undefined;
    const handleCreateNewPlan = () => onCreateOrder(plan.key, quantity);
    const handleUpdatePlan = () => onCreatePortalSession('subscription_update_confirm');
    const handleCancelPlan = () => onCreatePortalSession('subscription_cancel');
    if (isEnterprise) {
        return (_jsx(Button, { type: "primary", href: txt('contactOptions'), target: "_blank", rel: "noopener noreferrer", "aria-label": txt('contactSales'), children: txt('contactSales') }));
    }
    if (isBeeyStart && isEditionCanceling) {
        return (_jsx(Button, { type: "primary", onClick: handleCreateNewPlan, "aria-label": txt('topUpCredit'), children: txt('topUpCredit') }));
    }
    if (isBeeyStart && !isCurrentActive) {
        return (_jsx(Button, { type: "primary", onClick: handleCancelPlan, "aria-label": txt('cancelPaidPlan'), children: txt('cancelPaidPlan') }));
    }
    if (isCurrentActive) {
        if (isBeey) {
            return (_jsx(Button, { type: "primary", disabled: true, "aria-label": txt('currentPlan'), children: txt('currentPlan') }));
        }
        return (_jsx(Button, { type: "primary", onClick: handleCancelPlan, "aria-label": txt('cancelPaidPlan'), children: txt('cancelPaidPlan') }));
    }
    if (isOtherEditionPlanActive(editionSubscriptions, plan.key)) {
        return (_jsx(Button, { type: "primary", onClick: handleUpdatePlan, "aria-label": txt('getPlan'), children: txt('getPlan') }));
    }
    if (!isOtherEditionPlanActive(editionSubscriptions, plan.key)) {
        return (_jsx(Button, { type: "primary", onClick: handleCreateNewPlan, "aria-label": isEditionCanceling ? txt('getPlanAgain') : txt('getPlan'), children: isEditionCanceling ? txt('getPlanAgain') : txt('getPlan') }));
    }
    return (_jsx(Button, { type: "primary", disabled: true, "aria-label": txt('notAvailable'), children: txt('notAvailable') }));
};
export default PurchaseButton;
